import React from 'react';
import { Button } from '@chaser/components';
import AccountsIQModal from '../AccountsIQModal/index.jsx';
import SageIntacctModal from '../SageIntacctModal/index.jsx';
import { useHistory } from 'react-router';
import OpenAPIModal from '../OpenAPIModal/index.jsx';
import { DemoIntegrations, Integrations } from '../../../../util/constants';
import useModal from '../../../../hooks/useModal';
import usePush from '../../../../hooks/usePush';
import ConnectService from '../../../../services/connect-service';
import OdooModal from '../OdooModal/index.jsx';
import StripeModal from '../StripeModal/index.jsx';
import { pendo } from '../../../../util/logging';

function ConnectButton({ selectedIntegration }) {
  const history = useHistory();
  const { execute, loading } = usePush(ConnectService.connect, {
    errorToast: 'Failed to connect',
  });
  const showModal = useModal();

  async function handleSubmit(selectedIntegration) {
    pendo.track('integration_connect_clicked', {
      integration: selectedIntegration,
    });

    switch (selectedIntegration) {
      case Integrations.ACCOUNTSIQ:
        showModal(<AccountsIQModal />);
        break;
      case Integrations.SAGEINTACCT:
        showModal(<SageIntacctModal />);
        break;
      case Integrations.CSV:
        history.push('/addorganisation/csvconfiguration');
        break;
      case Integrations.OPENAPI:
        showModal(<OpenAPIModal integrationType={selectedIntegration} />);
        break;
      case Integrations.ZAPIER:
        showModal(<OpenAPIModal integrationType={selectedIntegration} />);
        break;
      case Integrations.SAGE50:
        showModal(<OpenAPIModal integrationType={selectedIntegration} />);
        break;
      case DemoIntegrations.OPENAPI:
        showModal(<OpenAPIModal integrationType={Integrations.OPENAPI} sandbox />);
        break;
      case Integrations.ODOO:
        showModal(<OdooModal />);
        break;
      case Integrations.STRIPE:
        showModal(<StripeModal />);
        break;
      default: {
        const [err, url] = await execute(selectedIntegration);
        if (err) return;
        window.location = url;
      }
    }
  }

  return (
    <Button
      loading={loading}
      type="submit"
      data-testid="connect-btn"
      data-trackingid="connect-btn"
      id="submit-addclient-btn"
      disabled={!selectedIntegration}
      onClick={() => handleSubmit(selectedIntegration)}
    >
      Connect
    </Button>
  );
}

export default ConnectButton;
